module.exports = __webpack_public_path__ + "img/icon_p3_151.574e6db4.png";